export default {
    OPEN: 'ModalElementOpen',
    CLOSE: 'ModalElementClose',
};
